import { createSelector } from 'reselect';

const selector = state => {
  return state.projects.items.asMutable({ deep: true });
}

export default createSelector(
  [selector], result => result
)



// WEBPACK FOOTER //
// ./src/selectors/projects-selector.js